<template>
    <div class="main-content">
        <h4>User Maintenance: Edit</h4>
        <p class="diagonal-lines"></p>
        <success v-if="success" class="my-2">
            {{ updatedUser.f_name }} {{ updatedUser.l_name }} has been successfully archived.
        </success>
        <section class="search-user">
            <div class="mt-5 mb-3">
                <form action="?" method="GET" >
                   <strong class="mr-2">ENTER EMAIL ADDRESS:</strong><br>
                    <input type="text" name="email"  v-model="searchUser" placeholder="Enter Email Address">
                </form>
            </div>
            <div v-if="showList">
                <ul class="mb-5">
                    <li v-for="(user,index) in userList" :key="index" class="d-flex flex-column justify-content-start">
                        <p><strong>{{ user.f_name }} {{ user.l_name }}</strong></p>
                        <p><strong>Email: </strong>{{ user.email }}</p>
                        <p><strong>Company: </strong>{{ user.company }}</p>
                        <p class="mt-3">
                            <router-link :to="{name:'editUser', params:{id:user.id}}" class="btn-round-green pt9rem mr-2">edit User</router-link>

                            <span class="btn-round-red pt9rem" data-toggle="modal" :data-target="'#archive-'+user.id">Archive user</span>
                            <modal :id="'archive-'+user.id" title="Archive" @confirmFunction="archive(user.id)">
                                Do you want to archive {{user.f_name}} {{ user.l_name }} ?
                            </modal>
                        </p>
                    </li>
                </ul>

            </div>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showList:false,
            userList:[],
            searchUser:null,
            success:false,
            updatedUser:{}
        };
    },

    created() {

    },
    mounted() {


    },
    methods:{
        archive(id){

            axios.get(`/api/user/archive/${id}/`).then(response => {
                this.updatedUser=response.data;
                this.success=true;
                this.showList=false;
                this.searchUser=null;
                $("#archive-"+id).modal('hide');
            });
        },
    },
    watch:{
        // on change search input value
        async searchUser(newInput){
            if(newInput.length>2){
                if(newInput=="" || newInput==null){
                    this.userList=[];
                    this.showList=false;
                }else{
                    try {
                        await axios.get(`/api/searchUser/${newInput}/`).then(response => {
                            this.showList=true;
                            this.userList=response.data;
                            if(this.userList.length==0){
                                this.userList=[];
                                this.showList=false;
                                this.noRecord=true;
                            }

                        });

                    } catch (error) {
                        this.showList=false;
                        this.errors = error.response && error.response.data.errors;
                    }
                }
            }else{
                this.userList=[];
                    this.showList=false;
            }


        },
    }

}
</script>
